import { ApiCall } from '@lcms/api-definition';
import endpoints from '../../endpoints';
import { IndexModel } from '../../../types/index-model';

export type EndpointResponse = IndexModel[];

export default new ApiCall<EndpointResponse>().get('indices', {
    route: endpoints.abbreviationIndices,
});
